import(/* webpackMode: "eager", webpackExports: ["Top"] */ "/codebuild/output/src234616500/src/components/top.tsx");
